import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SettingsData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SettingsDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SettingsDataStore",
			variables: false,
		})
	}
}

export async function load_SettingsData(params) {
  await initClient()

	const store = new SettingsDataStore()

	await store.fetch(params)

	return {
		SettingsData: store,
	}
}
